import { useQueryClient } from '@tanstack/react-query';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { CreateFileDto } from '../../types/vault.types';
import { useIdempotentAppMutation } from '../use-idempotent-app-mutation.hook';

export const useCreateFile = () => {
  const queryClient = useQueryClient();

  const { mutate: create, isPending } = useIdempotentAppMutation([QueryKey.CREATE_FILE], {
    mutationFn: ({ companyId, data }: { companyId: string; data: CreateFileDto }, { headers }) =>
      ApiService.post(
        { endpoint: BackendRoute.COMPANIES, routePath: [companyId, 'vault', 'files'] },
        { body: data, headers },
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKey.GET_EVENT] });
      queryClient.invalidateQueries({ queryKey: [QueryKey.GET_EVENT_TRANSACTIONS] });
      queryClient.invalidateQueries({ queryKey: [QueryKey.GET_EVENT_TRANSACTIONS_COUNT] });
    },
  });
  return { create, isPending };
};
